import { useOptionalSession } from 'src/contexts/SessionContext';
import { FeatureFlag } from 'src/models/platform/_types';
import { hasFeatureFlag } from 'src/shared/usePermissionCheck';

export function useReactPlanCreatorEnabled(): boolean {
  const { session } = useOptionalSession();

  return Boolean(
    session && hasFeatureFlag(session, FeatureFlag.ReactPlanCreator)
  );
}
